import { requestJson } from "./instateamAdminApi";

function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
}

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
  };
}

export function getAdminChatOverview(token, params = {}) {
  return requestJson(`/instateam/chat/admin/overview${buildQueryString(params)}`, {
    headers: authHeaders(token),
  });
}

export function searchAdminChatDirectory(token, params = {}) {
  return requestJson(`/instateam/chat/admin/directory${buildQueryString(params)}`, {
    headers: authHeaders(token),
  });
}

export function startAdminDirectChat(token, payload) {
  return requestJson("/instateam/chat/admin/direct", {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function createAdminGroupChat(token, payload) {
  return requestJson("/instateam/chat/admin/groups", {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function sendAdminChatMessage(token, conversationId, formData) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/messages`, {
    method: "POST",
    headers: authHeaders(token),
    body: formData,
  });
}

export function markAdminChatRead(token, conversationId) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/read`, {
    method: "POST",
    headers: authHeaders(token),
  });
}

export function toggleAdminChatBlock(token, conversationId, blocked) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/block`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ blocked }),
  });
}

export function toggleAdminChatMute(token, conversationId, muted) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/mute`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ muted }),
  });
}

export function leaveAdminGroupChat(token, conversationId) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/leave`, {
    method: "PATCH",
    headers: authHeaders(token),
  });
}

export function updateAdminGroupMembers(token, conversationId, payload) {
  return requestJson(`/instateam/chat/admin/conversations/${conversationId}/members`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function toggleAdminMessageReaction(token, messageId, emoji) {
  return requestJson(`/instateam/chat/admin/messages/${messageId}/reaction`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ emoji }),
  });
}

export function forwardAdminMessage(token, messageId, conversationId) {
  return requestJson(`/instateam/chat/admin/messages/${messageId}/forward`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ conversationId }),
  });
}

export function deleteAdminMessage(token, messageId, scope) {
  return requestJson(`/instateam/chat/admin/messages/${messageId}/delete`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ scope }),
  });
}
